// [목적] 디자인 시안 기준 3단(Mobile/Tablet/Desktop) 뷰포트 폭 추적 훅
// [이유] docs/플리오랩/web/shell.jsx 의 useViewport 포팅 — 페이지 컴포넌트들이 칼럼/스플릿 분기에 사용
// [사이드 이팩트] resize 이벤트 리스너 1개 추가. SSR 대비 typeof window 가드 포함
// [수정 시 고려사항] breakpoint 값(768/1180)은 design_structure §5 와 정합. 변경 시 동기화 필요

import { useEffect, useState } from 'react';

export interface Viewport {
  w: number;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

export function useViewport(): Viewport {
  const [w, setW] = useState<number>(typeof window !== 'undefined' ? window.innerWidth : 1440);
  useEffect(() => {
    const onResize = (): void => setW(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return {
    w,
    isMobile: w < 768,
    isTablet: w >= 768 && w < 1180,
    isDesktop: w >= 1180,
  };
}
